<template>
  <div class="ARvisit">
    <!-- 顶部区域 -->
    <div class="fl">
      <img
        src="../../../../assets/images/newIcon/vipportrait_day_icon@2x.png"
        alt=""
      />
      <span></span><b style="font-weight:500;">{{title}}</b>
    </div>
    <span class="text">{{date}}</span>
    <!-- 数字区域 -->
    <div v-show="isnum" class="mian">
      <!-- 左侧数字 -->
      <div class="lnum">
        <div class="m2">
          <span style="font-size: 14px"> &nbsp7-27 &nbsp&nbsp(二)</span>
          <span style="font-size: 43px; font-weight: bold"
            >26.2<span style="font-size: 14px;font-weight:400;">{{text}}</span>
          </span>
        </div>
        <div class="m3">
          <span style="font-size:12px;"
            >环比
            <span style="color: #ff4343; font-size: 12px; font-weight: 600"
              >5.9%</span
            ><i style="color: #ff4343; font-weight: 600" class="el-icon-top"></i
          ></span>
          <span style="font-size:12px;"
            >同比
            <span style="color: #19e9aa; font-size: 12px; font-weight: 600"
              >5.9%</span
            ><i
              style="color: #19e9aa; font-weight: 600"
              class="el-icon-bottom"
            ></i
          ></span>
        </div>
      </div>
      <!-- 右侧数字 -->
      <div class="rnum">
        <p class="bigsize">
          <span class="smallsize">合计：</span>{{rt}}<span class="smallsize"
            >{{text}}</span
          >
        </p>
        <p class="bigsize">
          <span class="smallsize">均值：</span>31,123<span class="smallsize"
            >{{text}}</span
          >
        </p>
      </div>
    </div>
    <div :id="did" style="margin-top: 20px"></div>
  </div>
</template>

<script>
export default {
//   props: ["did","title","date","isnum"],
  props:{
      did:{},
      title:{},
      date:{},
      isnum:{
          default:true
      },
      text:{},
      rt:{}
  },
  data(){
      return{
          data: [
        { data: "6.21", name:this.title, val: 120 },
        { data: "6.22", name:this.title, val: 750 },
        { data: "6.23", name:this.title, val: 270 },
        { data: "6.24", name:this.title, val: 280 },
        { data: "6.25", name:this.title, val: 850 },
        { data: "6.26", name:this.title, val: 150 },
        { data: "6.27", name:this.title, val: 700 },
        { data: "6.28", name:this.title, val: 140 },
        { data: "6.29", name:this.title, val: 120 },
        { data: "...", name:this.title, val: 130 },
      ],
      }
  },
  mounted() {
      this.init(this.did,this.data)
  },
  methods: {
    //线图
    init(id, data, height) {
      const chart = new this.$chart({
        container: id,
        autoFit: true,
        height: height || 300,
      });
      // chart
      // .interval({
      //     theme: {
      //     defaultColor: 'red',
      //     },
      // })
      // .position(0);
      chart.data(data);
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      });
      chart.scale("val", {
        min: 0,
        max: 1000,
      });
      chart.tooltip({
        showCrosshairs: false,
        shared: true,
        showMarkers: false,
      });
      chart.axis("val", {
        label: {
          formatter: (val) => {
            return val;
          },
        },
      });

      chart.line().position("data*val").shape("smooth").color("name");

      // chart.point().position("data*val").shape("circle");

      chart.render();
    },
  },
};
</script>

<style lang="less">
.ARvisit {
  .fl {
    font-size: 16px;
    display: flex;
    align-items: center;
    b {
      margin-left: 10px;
    }
    img {
      width: 24px;
    }
  }
  .text {
    display: block;
    margin-left: 12px;
    color: #333;
    font-size: 12px;
    line-height: 24px;
    margin-top: 10px;
  }
  //数字样式
  .mian {
    display: flex;
    justify-content: space-between;
    .lnum {
      display: flex;
      .m2 {
        margin-left: 20px;
        margin-bottom: -5px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        color: #0091ff;
      }
      .m3 {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
    }
    .rnum {
      margin-right: 60px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &:after {
        content: "";
        width: 2px;
        height: 40px;
        background-color: #333;
        position: absolute;
        top: 16px;
        left: -20px;
      }
    }
  }
 //公共区
  .bigsize {
    font-size: 28px;
    font-weight: 500;
  }
  .smallsize {
    font-size: 12px;
    font-weight: normal;
  }
}
</style>